import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { CalendarioProvider } from '../providers/calendario/calendario'
// import { AuthService } from '../services/auth.service';
import { Storage } from '@ionic/storage';
import { Keyboard } from '@ionic-native/keyboard';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = 'HomePage';

  pages: Array<{ title: string, component: any }>;

  constructor(private keyboard: Keyboard,public store: Storage, public calProv: CalendarioProvider, public platform: Platform, public statusBar: StatusBar, public splashScreen: SplashScreen) {
    this.initializeApp();

    if (window.localStorage.getItem('email') && window.localStorage.getItem("abilitato") == "true") {
      if (window.localStorage.getItem('email') == "admin@sc.it" || window.localStorage.getItem('email') == "boldasyouare@gmail.com") {

        this.rootPage = "DashboardIstruttorePage";

      } else {
        this.rootPage = "HomePage";

      }
    } else {
      this.rootPage = "home-bold";
    }


    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'Signin', component: 'SigninPage' },
      { title: 'Signup', component: 'SignupPage' },
      { title: 'Raccolta', component: 'HomePage' },
      { title: 'Segnalazioni', component: 'SegnalazioniPage' },
      { title: 'Calendario', component: 'CalendarPage' },

      // { title: 'List', component: 'ListPage' },
      { title: 'Dizionario', component: 'OverviewPage' },
      { title: 'Ritiro Ingombranti', component: 'GroupsPage' },
      // { title: 'Create', component: 'CreatePage' },
      // { title: 'Intro', component: 'IntroPage' },
      // { title: 'Timeline', component: 'TimelinePage' },
      // { title: 'Settings', component: 'SettingsPage' },
      { title: 'L\'applicazione', component: 'MapPage' },
      { title: 'Comunicati', component: 'ListPage' }
    ];
  }
  initializeApp() {
    this.keyboard.disableScroll(false);
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();

    });
    // this.auth.afAuth.authState
    // .subscribe(
    //   user => {
    //     if (user) {
    //       this.nav.setRoot('HomePage');
    //       this.nav.popToRoot();
    //     } else {
    //       // this.rootPage = this.nav.setRoot('SigninPage');
    //     this.nav.setRoot('HomePage');
    //     this.nav.popToRoot();
    //
    //     }
    //   },
    //   () => {
    //     // this.rootPage = this.nav.setRoot('SigninPage');
    //     this.nav.setRoot('HomePage');
    //     this.nav.popToRoot();
    //
    //   }
    // );
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page);

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts